import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private isDarkModeSubject = new BehaviorSubject<boolean>(false);
  isDarkMode$ = this.isDarkModeSubject.asObservable();
  
  private readonly THEME_KEY = 'insizon-theme';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.initTheme();
  }

  private initTheme(): void {
    if (isPlatformBrowser(this.platformId)) {
      const savedTheme = localStorage.getItem(this.THEME_KEY);
      if (savedTheme) {
        this.setDarkMode(savedTheme === 'dark');
      } else {
        // Check system preference
        const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        this.setDarkMode(prefersDark);
      }
    }
  }

  public setDarkMode(isDark: boolean): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isDarkModeSubject.next(isDark);
      if (isDark) {
        document.documentElement.setAttribute('data-bs-theme', 'dark');
        localStorage.setItem(this.THEME_KEY, 'dark');
      } else {
        document.documentElement.setAttribute('data-bs-theme', 'light');
        localStorage.setItem(this.THEME_KEY, 'light');
      }
    }
  }

  public toggleTheme(): void {
    this.setDarkMode(!this.isDarkModeSubject.value);
  }
}
